<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Area/POA/components/Budget/components/Available'

    export default {
        components: {
            Grid,
        }
    }
</script>